export const FALLBACK_MIME = 'application/octet-stream' as const;
export type FallbackMimeType = typeof FALLBACK_MIME;

export enum BaseFileExtension {
  pdf = 'pdf',
  png = 'png',
  jpg = 'jpg',
  jpeg = 'jpeg',
  csv = 'csv',
  zip = 'zip',
  xlsx = 'xlsx',
}

export enum BaseMimeType {
  pdf = 'application/pdf',
  png = 'image/png',
  jpeg = 'image/jpeg',
  csv = 'text/csv',
  zip = 'application/zip',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
